import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiInstance } from '../../axiosApi';

const initialState = {};

export const processList = createAsyncThunk('call/process', async () => {
  return await apiInstance.get('/process');
});

export const processData = createAsyncThunk('call/realtime-process', async (params) => {
  return await apiInstance.get('/realtime/process', { params });
});

export const realtimeCountGet = createAsyncThunk('call/count', async (params) => {
  return await apiInstance.get('/realtime/count', { params });
});

export const realtimeListGet = createAsyncThunk('call/list', async (params) => {
  return await apiInstance.get('/realtime/list', { params });
});

export const realtimeLiveDataGet = createAsyncThunk('call/live-data', async (params) => {
  return await apiInstance.get('/realtime/live-data', { params });
});

export const userLogout = createAsyncThunk('call/logout', async (payload) => {
  return await apiInstance.post('/logout', payload);
});

export const callWhisper = createAsyncThunk('call/call_whisper', async (payload) => {
  return await apiInstance.post('/call_originate/call_whisper', payload);
});

export const callBarging = createAsyncThunk('call/call_barging', async (payload) => {
  return await apiInstance.post('/call_originate/call_barging', payload);
});

export const callMonitor = createAsyncThunk('call/call_monitor', async (payload) => {
  return await apiInstance.post('/call_originate/call_monitor', payload);
});

export const clearBufferReport = createAsyncThunk('call/clear-buffer', async (params) => {
  return await apiInstance.get('/realtime/clear-buffer', { params });
});

export const hardReset = createAsyncThunk('call/realtime/hard_reset', async () => {
  return await apiInstance.get('/realtime/hard_reset');
});

export const reportProcessList = createAsyncThunk('voicebroadcast_realtime/process', async () => {
  return await apiInstance.get('/voicebroadcast_realtime/process');
});

export const reportProcessData = createAsyncThunk(
  'call/voicebroadcast_realtime-process',
  async (params) => {
    return await apiInstance.get('/voicebroadcast_realtime/process', { params });
  }
);

export const clearBroadcastBufferReport = createAsyncThunk(
  'call/broadcast-clear-buffer',
  async (params) => {
    return await apiInstance.get('/realtime/broadcast-clear-buffer', { params });
  }
);

export const reportDetailsGet = createAsyncThunk(
  'call//voicebroadcast_realtime/list',
  async (params) => {
    return await apiInstance.get('/voicebroadcast_realtime/list', { params });
  }
);

export const recentCallGet = createAsyncThunk('call/recent-call-report', async (params) => {
  return await apiInstance.get('/recent-call-report', { params });
});

const realtimeReportSlice = createSlice({
  name: 'realtimeReport',
  initialState,
  reducers: {
    clearRealtimeReportSlice: () => initialState
  },
  extraReducers: (builder) => {}
});

export default realtimeReportSlice.reducer;
export const { clearRealtimeReportSlice } = realtimeReportSlice.actions;
